import {Dimensions, StyleSheet} from 'react-native';
import {colorPalette, defaultTheme} from '../../../../../theme';

export default StyleSheet.create({
  title: {marginTop: 24, marginHorizontal: 0},
  button: {
    marginTop: 40,
    marginBottom: 20,
  },
  container: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
    alignItems: 'center',
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0.3)',
    position: 'absolute',
  },
  content: {
    backgroundColor: defaultTheme.colors.whiteGrey0,
    width: Dimensions.get('window').width,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    paddingHorizontal: 16,
    zIndex: 1000,
    position: 'absolute',
    bottom: 0,
  },
  closeBtn: {
    alignSelf: 'flex-end',
    marginTop: 10,
    marginBottom: -3,
  },
  indicator: {
    backgroundColor: colorPalette.secondaryLighter2,
    height: 2,
    width: 36,
    marginTop: 10,
    marginBottom: 4,
    alignSelf: 'center',
  },
  input: {
    marginHorizontal: 16,
    height: 100,
  },
});
